import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonComponentModule } from '../common/common.module';
import { FormsModule } from '@angular/forms';
import { ImageCarouselTempModule } from '../common/image-carousel-temp/image-carousel-temp.module';
import { MediaCarouselModule } from '../common/media-carousel/media-carousel.module';



@NgModule({
  declarations: [MenuItemComponent],
  imports: [
    CommonModule,
    CommonComponentModule,
    FormsModule,
    ImageCarouselTempModule,
    MediaCarouselModule,
    SharedModule
  ],
  exports:[MenuItemComponent]
})
export class MenuModule { }

// translation loader moved to SharedModule
